// extracted by mini-css-extract-plugin
export default {"contentFooter":"PageContentFooter-contentFooter-RHpBL"};